var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "dropzone" } },
    [
      _vm._l(_vm.trayData, function(item, id) {
        return [
          _c(
            "div",
            {
              staticClass: "draggable-card",
              class: [_vm.selectedTile == id ? "selected" : "not-selected"],
              style: [
                item.backgroundTileImage
                  ? {
                      backgroundImage: "url('" + item.backgroundTileImage + "')"
                    }
                  : { backgroundColor: item.hexColor },
                { backgroundColor: item.hexColor },
                {
                  width:
                    _vm.handleResize(
                      item.tileWidth,
                      item.tileHeight,
                      item.productType
                    ).width + "px"
                },
                {
                  height:
                    _vm.handleResize(
                      item.tileWidth,
                      item.tileHeight,
                      item.productType
                    ).height + "px"
                },
                {
                  transform:
                    "translate(" +
                    item.tileLeftOffset +
                    "px, " +
                    item.tileTopOffset +
                    "px) " +
                    (item.isRotated ? "rotate(90deg)" : "rotate(0deg)")
                },
                { zIndex: item.imageZIndex },
                { backgroundSize: "cover" }
              ],
              attrs: {
                id: id,
                "data-x": item.tileLeftOffset,
                "data-y": item.tileTopOffset,
                "data-r": item.isRotated ? "90" : "0",
                "data-inventoryType": item.inventoryType
              },
              on: {
                mousedown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "left", 37, $event.key, [
                      "Left",
                      "ArrowLeft"
                    ])
                  ) {
                    return null
                  }
                  if ("button" in $event && $event.button !== 0) {
                    return null
                  }
                  $event.preventDefault()
                  $event.stopPropagation()
                  _vm.toggleSelectedTile(id)
                  _vm.changeZIndex(id, "9999")
                },
                touchstart: function($event) {
                  _vm.toggleSelectedTile(id)
                  _vm.changeZIndex(id, "9999")
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "tooltip text-capitalize",
                  class: [item.isRotated ? "rotated" : ""]
                },
                [
                  item.inventoryType == "Resilient" ||
                  item.inventoryType == "Carpet"
                    ? [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              item.sellingStyleName
                                ? item.sellingStyleName
                                : item.styleName
                            ) +
                            " " +
                            _vm._s(item.sellingStyleNumber)
                        ),
                        _c("br"),
                        _vm._v(
                          "\n          " +
                            _vm._s(item.colorName) +
                            " " +
                            _vm._s(item.colorNumber)
                        ),
                        _c("br"),
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              item.productTypeDesc
                                ? item.productTypeDesc + "/"
                                : ""
                            ) +
                            _vm._s(item.swatchWidth) +
                            "x" +
                            _vm._s(item.swatchLength)
                        ),
                        _c("br")
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  item.inventoryType === "Inspiration"
                    ? [
                        _vm._v("\n          " + _vm._s(item.colorName) + " "),
                        _c("br")
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isPomInventoryType(item)
                    ? [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$resourceString["virtualtray.pom"]) +
                            " " +
                            _vm._s(item.colorNumber) +
                            " "
                        ),
                        _c("br")
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  item.inventoryType && item.inventoryType === "Paint"
                    ? [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$resourceString["virtualtray.paint"]) +
                            " " +
                            _vm._s(item.colorNumber) +
                            "\n          " +
                            _vm._s(item.colorName) +
                            " "
                        ),
                        _c("br")
                      ]
                    : _vm._e(),
                  _vm._v(
                    "\n        " +
                      _vm._s(item.collection ? item.collection : "") +
                      "\n      "
                  )
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "remove",
                  class: [item.isRotated ? "rotated" : ""],
                  on: {
                    mousedown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "left", 37, $event.key, [
                          "Left",
                          "ArrowLeft"
                        ])
                      ) {
                        return null
                      }
                      if ("button" in $event && $event.button !== 0) {
                        return null
                      }
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.$emit("trayDeleteItem", id)
                    }
                  }
                },
                [
                  _c("Icon", {
                    staticClass: "remove",
                    attrs: {
                      icon: "bx:bx-x",
                      height: "1.5em",
                      "aria-hidden": "true"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              item.inventoryType == "Carpet" ||
              item.inventoryType == "Resilient"
                ? _c(
                    "div",
                    {
                      staticClass: "rotate",
                      class: [item.isRotated ? "rotated" : ""],
                      on: {
                        mousedown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "left", 37, $event.key, [
                              "Left",
                              "ArrowLeft"
                            ])
                          ) {
                            return null
                          }
                          if ("button" in $event && $event.button !== 0) {
                            return null
                          }
                          $event.preventDefault()
                          $event.stopPropagation()
                          ;[
                            _vm.toggleSelectedTile(""),
                            _vm.swapHeightWidth(item)
                          ]
                        }
                      }
                    },
                    [
                      _c("Icon", {
                        attrs: {
                          icon: "dashicons:image-rotate",
                          "vertical-flip": true
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }